import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import PlanModal from '../UserPlan/PlanModal';
import { getSubscriptionType } from '../../utils';
import { WORK_SUB_TYPE_MUSICAL_COMPOSITION } from '../../constants';

class NewAgreement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      planModalOpen: false,
      isPremiumExpired: false,
    };
  }

  handleCreate(e) {
    e.preventDefault();
    this.props.hideAlert();

    const {
      type,
      router,
      status,
      members,
      profile,
      agreementType,
      workSubType,
      subscription,
    } = this.props;
    const subscriptionPlan = profile.subscription_plan;
    const { planType } = getSubscriptionType(subscriptionPlan, subscription);

    if (type === 'create') {
      this.props.resetContractBlockContents();

      if (
        status === actionTypes.MEMBERS_GET_SUCCESS ||
        status === actionTypes.MEMBER_ADD
      ) {
        if (members.length < 2) {
          this.props.alert(
            'error',
            'Oops! Please go back and select a team with more than 1 person.'
          );
        } else {
          if (agreementType === 0 || agreementType === 1) {
            if (agreementType === 0) {
              // Split agreement
              router.push('/create/agreement-ownership-split');
              return;
            }
            if (agreementType === 1) {
              // Premium split agreement
              router.push('/create/agreement-ownership-premium-split');
              return;
            }
          }
          if (agreementType === 2) {
            // Work for hire agreement
            if (profile.subscription_plan === 'pro-annual') {
              router.push('/create/agreement-work-for-hire');
              return;
            }

            if (members.length > 2) {
              this.props.alert(
                'error',
                'You cannot use a team that has more than 2 collaborators for a work for hire agreement.'
              );
              return;
            }

            if (
              profile.subscription_plan === 'premium' &&
              profile.trial_expired === true
            ) {
              // Show upgrade modal for expired premium user
              this.setState({ planModalOpen: true, isPremiumExpired: true });
            } else {
              if (planType === 'premium') {
                router.push('/create/agreement-work-for-hire');
              } else {
                this.setState({ planModalOpen: true, isPremiumExpired: false });
              }
            }
          }
          if (agreementType === 3) {
            // Producer agreement
            if (profile.subscription_plan === 'pro-annual') {
              router.push('/create/agreement-producer');
              return;
            }

            if (
              profile.subscription_plan === 'premium' &&
              profile.trial_expired === true
            ) {
              // Show upgrade modal for expired premium user
              this.setState({ planModalOpen: true, isPremiumExpired: true });
            } else {
              if (workSubType === WORK_SUB_TYPE_MUSICAL_COMPOSITION) {
                // If select "Music composition", show an error
                this.props.alert(
                  'error',
                  'Sorry, to create a Producer Agreement, go back and select "Sound Recording" as your work type'
                );
                return;
              }
              if (members.length > 2) {
                this.props.alert(
                  'error',
                  'You cannot use a team that has more than 2 collaborators for a producer agreement.'
                );
                return;
              }

              if (planType === 'premium') {
                router.push('/create/agreement-producer');
              } else {
                this.setState({ planModalOpen: true, isPremiumExpired: false });
              }
            }
          }
        }
      }
    } else {
      // router.push('/agreements/create');
    }
  }

  hidePlanModal = (type) => {
    const { agreementType, router } = this.props;

    this.setState({ planModalOpen: false }, () => {
      if (type) {
        if (agreementType === 2) {
          router.push('/create/agreement-work-for-hire');
        } else if (agreementType === 3) {
          router.push('/create/agreement-producer');
        }
      }
    });
  };

  render() {
    const { subscription, profile, agreementType } = this.props;
    const { planModalOpen, isPremiumExpired } = this.state;

    return (
      <div
        className="agreement agreement-border"
        onClick={(e) => this.handleCreate(e)}
      >
        <div className="new-item">
          <div className="new-text agreement-title">
            <span className="text-gray">{this.props.title}</span>
          </div>
        </div>

        <PlanModal
          show={planModalOpen}
          subscriptionPlan={profile.subscription_plan}
          referrer={profile.referrer}
          // showCheckoutStep={isPremiumExpired}
          isPremiumExpired={isPremiumExpired}
          showAllPlan={isPremiumExpired}
          agreementType={agreementType}
          isCanceledSubscription={
            subscription &&
            subscription.status === 'Canceled' &&
            profile.subscription_plan === 'free'
          }
          hidePlanModal={this.hidePlanModal}
        />
      </div>
    );
  }
}

NewAgreement.propTypes = {
  agreementType: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  status: state.users.status,
  members: state.users.members,
  fields: state.create.fields,
  profile: state.profile,
  subscription: state.payment.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  resetContractBlockContents: () => {
    dispatch(actions.resetContractBlockContents());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NewAgreement));



// WEBPACK FOOTER //
// src/components/Agreements/NewAgreement.jsx